export default "__VITE_ASSET__DicQBcwS__"